import * as React from 'react';
export default function SvgTrampoline() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5 10c0-.798.557-1.657 1.753-2.358C8.43 6.952 10.107 6.5 12 6.5c1.893 0 3.57.451 4.747 1.142 1.196.7 1.753 1.56 1.753 2.358s-.557 1.657-1.753 2.358C15.57 13.048 13.893 13.5 12 13.5c-1.893 0-3.57-.451-4.747-1.142C6.057 11.658 5.5 10.798 5.5 10Zm13 2.944v2.306a.75.75 0 0 0 1.5 0V10c0-1.55-1.066-2.815-2.494-3.652C16.06 5.5 14.112 5 12 5s-4.06.5-5.506 1.348C5.066 7.185 4 8.45 4 10v5.25a.75.75 0 0 0 1.5 0v-2.306c.301.262.636.498.994.708 1.273.747 2.936 1.223 4.756 1.327v3.271a.75.75 0 0 0 1.5 0v-3.271c1.82-.104 3.483-.58 4.756-1.327a6.65 6.65 0 0 0 .994-.707Z",
    fill: "currentColor"
  }));
}